// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type DeleteObjectDefinitionMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type DeleteObjectDefinitionMutation = { deleteCustomFieldDefinition?: boolean | null };

export const DeleteObjectDefinitionDocument = gql`
    mutation DeleteObjectDefinition($id: String!) {
  deleteCustomFieldDefinition(uid: $id)
}
    ` as unknown as DocumentNode<DeleteObjectDefinitionMutation, DeleteObjectDefinitionMutationVariables>;
